import React from 'react';
import { BlisterPackBadge } from './blisterPackBadge'

import { useLocation } from 'react-router-dom';

import {
	finalMissedRoute,
	todayMissedRoute,
	todayPendingRoute
} from '../../storage';

import { useAuthSelector } from '../../services/selectors/authSelector';

import * as Icons from '../../assets/svg/icons';
import * as routeNames from '../../routes/routeName';
import * as Hooks from '../../hooks';
import { Loader } from './loader';
import AnimatedBottomSheet from './animatedBottomSheet';

export const RouteConfirmation = ({ showConfirmationModal, setShowConfirmationModal }) => {

	const navigate = Hooks.useCustomNavigate();
	const location = useLocation()

	const { driverSelectedPharmacy } = useAuthSelector()

	return (
		<React.Fragment>
			<AnimatedBottomSheet
				isOpen={showConfirmationModal}
				onClose={() => setShowConfirmationModal(false)}
				ariaLabel="Exit Route Confirmation"
			>

						<div className="flex items-center justify-between p-2 px-4 md:p-3 border-b border-dashed rounded-t">
							<h3 className="text-sm font-bold text-gray-900">
								{driverSelectedPharmacy?.pharmacies?.name?.toUpperCase()}
							</h3>

							<button type="button"
								onClick={() => setShowConfirmationModal(false)}
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 
											ms-auto inline-flex justify-center items-center"
								data-modal-hide="bottom-right-modal">
								<Icons.CloseModelIcon />
								<span className="sr-only">Close modal</span>
							</button>

						</div>
						<div className="p-4 bg-white  rounded-md">
							<form>

								<div className="mb-4">
									<label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">
										Are you sure you want to exit from this route?
									</label>
								</div>

								<div className="flex justify-center items-center gap-2">

									{location.pathname.startsWith(routeNames.Missed_Route) ?
										<button onClick={() => {
											return localStorage.removeItem(todayMissedRoute),
												navigate(`${routeNames.DASHBOARD_PHARMACY}`)
										}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
											Yes
										</button> :
										location.pathname.startsWith(routeNames.driver_today_pending) ?
											<button onClick={() => {
												return localStorage.removeItem(todayPendingRoute),
													navigate(`${routeNames.DASHBOARD_PHARMACY}`)
											}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
												Yes
											</button> :
											location.pathname.startsWith(routeNames.driver_Missed_Route) ?
												<button onClick={() => {
													return localStorage.removeItem(finalMissedRoute),
														navigate(`${routeNames.DASHBOARD_PHARMACY}`)
												}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
													Yes
												</button> :

												<button onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
													Yes
												</button>}

									<button onClick={() => setShowConfirmationModal(false)} type="button" className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50">
										Cancel
									</button>

								</div>
							</form>
						</div>

			</AnimatedBottomSheet>
		</React.Fragment>
	)
}

export const MissedDeliveryConfirmation = ({
	showConfirmationModal,
	setShowConfirmationModal,
	handleMissedDelivery,
	missedData,
	missedExplanation,
	setMissedExplanation,
	missedExplanationError,
	setMissedExplanationError,
	isSubmitting = false,
}) => {

	const handleClose = () => {
		if (isSubmitting) return;
		setShowConfirmationModal(false);
		setMissedExplanation('');
		setMissedExplanationError('');
	};

	return (
		<React.Fragment>
			{showConfirmationModal ? (
				<div
					className="fixed inset-0 z-[9999] flex items-end justify-center bg-slate-950/55 p-2 backdrop-blur-[2px] sm:items-center sm:p-4"
					role="dialog"
					aria-modal="true"
					aria-labelledby="missed-delivery-title"
					onClick={handleClose}
				>
					<div
						className="w-full max-w-md overflow-hidden rounded-[24px] bg-white shadow-[0_24px_60px_rgba(15,23,42,0.28)]"
						onClick={(event) => event.stopPropagation()}
					>
						<div className="border-b border-slate-200 px-4 pb-3 pt-4 sm:px-5">
							<div className="flex items-start justify-between gap-3">
								<div className="min-w-0">
									<div className="flex items-center gap-2 min-w-0">
										<h3 id="missed-delivery-title" className="truncate text-lg font-semibold text-slate-900 sm:text-xl">
											{missedData?.first_name} {missedData?.last_name}
										</h3>
										{missedData?.is_blister_flexi && (
											<BlisterPackBadge />
										)}
									</div>
								</div>
								<button
									type="button"
									onClick={handleClose}
									disabled={isSubmitting}
									className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 transition hover:border-slate-300 hover:bg-slate-100 hover:text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
								>
									<Icons.CloseModelIcon />
									<span className="sr-only">Close modal</span>
								</button>
							</div>
							<p className="mt-3 rounded-2xl bg-slate-50 px-3 py-2.5 text-sm font-medium leading-6 text-slate-700">
								Are you sure you want to mark this delivery as missed?
							</p>
						</div>

						<div className="max-h-[70vh] overflow-y-auto px-4 py-3 sm:px-5 sm:py-4">
							<form>
								<div>
									<textarea
										id="missed-explanation"
										value={missedExplanation}
										onChange={(event) => {
											setMissedExplanation(event.target.value);
											if (missedExplanationError) {
												setMissedExplanationError('');
											}
										}}
										rows={5}
										placeholder="Enter the reason for the missed medication"
										className={`min-h-[128px] w-full resize-none rounded-2xl border bg-slate-50 px-4 py-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:bg-white focus:ring-4 focus:ring-red-100 ${
											missedExplanationError ? 'border-red-400 focus:border-red-500' : 'border-slate-200 focus:border-red-400'
										}`}
									/>
									{missedExplanationError ? (
										<p className="mt-2 text-sm font-medium text-red-600">{missedExplanationError}</p>
									) : null}
								</div>

								<div className="mt-4 flex flex-col-reverse gap-2.5 sm:flex-row sm:justify-end">
									<button
										onClick={handleClose}
										type="button"
										disabled={isSubmitting}
										className="inline-flex min-h-[48px] items-center justify-center rounded-2xl border border-slate-200 bg-slate-100 px-5 text-sm font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
									>
										Cancel
									</button>
									<button
										onClick={handleMissedDelivery}
										type="button"
										disabled={isSubmitting}
										className="inline-flex min-h-[48px] items-center justify-center rounded-2xl bg-red-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-100 disabled:cursor-not-allowed disabled:opacity-80"
									>
										{isSubmitting ? (
											<span className="flex items-center justify-center">
												<Loader />
											</span>
										) : (
											'Yes, mark missed'
										)}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			) : null}
		</React.Fragment>
	)
}
